import React from "react";
import { useEffect } from "react";

import "./modal.scss";

export default function Modal(props) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="general-modal-container">
      <div className="general-modal">{props.children}</div>
    </section>
  );
}
